import React from 'react';
import { observer } from 'mobx-react';
import { cn } from '@core/utils/cn';
import { Label } from '../../../components/label';
import { I18n } from '../../../core/i18n';
import { injectTSDI } from '../../../core/tsdi';
import { ActivityPointsDto } from '../../../core/api/FitnessActivityClient';

interface ActivityDetailsProps {
    activityPoints: ActivityPointsDto;
}

export const ActivityPointsDetails = observer(
    ({ activityPoints }: ActivityDetailsProps) => {
        const { formatDateTime } = injectTSDI(I18n);
        activityPoints.changes.sort((a, b) =>
            a.createdDate > b.createdDate ? 1 : -1
        );
        if (activityPoints.changes.length === 0) {
            return (
                <p className="text-sm text-muted-foreground">
                    No point changes recorded for this activity.
                </p>
            );
        }

        return (
            <div className="flex flex-col gap-2">
                <Label>Point changes</Label>
                <ul className="m-0 flex list-none flex-col gap-1 p-0">
                    {activityPoints.changes.map((activityPointChange) => (
                        <li
                            key={activityPointChange.createdDate}
                            className="flex items-baseline justify-between gap-4 text-sm"
                        >
                            <span className="text-muted-foreground">
                                {formatDateTime(
                                    activityPointChange.createdDate
                                )}
                            </span>
                            <span
                                className={cn(
                                    'tabular-nums',
                                    activityPointChange.value < 0
                                        ? 'text-destructive'
                                        : 'text-foreground'
                                )}
                            >
                                {activityPointChange.value > 0 ? '+' : ''}
                                {activityPointChange.value}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
);
